import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { DelegationBoxComponent } from './delegation-box/delegation-box.component';

@NgModule({
  declarations: [
    AppComponent,
    DelegationBoxComponent
  ],
  imports: [
    BrowserModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
